import React, {useState} from "react";
import {Btn, OrderFinalSummary} from "../components";
import {useCore, useEnsureCheckoutOpen} from "../hooks";
import {useNavigate} from "react-router";
import {Order} from "depoto-core";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {useGQL} from "../utils/GQLContext.ts";
import {
  getDateStringFromUTCString,
  prepareOrderItems,
  preparePaymentItems, Schema,
  wait
} from "../utils";
import {initOrder} from "../store/core/reducer.ts";
import {printDocument, printTicket} from "../utils/print.ts";

export const PreviewReservation: React.FC = () => {
  const [isFetching, setIsFetching] = useState<boolean>(false)
  const gql = useGQL()
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { core, currentOrder, setCurrentOrder, selectedCheckoutId } = useCore()
  const ensureCheckoutOpen = useEnsureCheckoutOpen()


  const { mutate: createReservation } = useMutation({
    mutationKey: ['createOrder'],
    // mutationFn: (data: ValueTypes['Order']) =>
    //   mutationFn: (data: ValueTypes['RootSchemaMutation']['createOrder']) =>
    mutationFn: () =>
      toast.promise(
        gql('mutation')({
          createOrder: [
            {
              checkout: Number(selectedCheckoutId),
              status: 'reservation',
              note: currentOrder.note,
              privateNote: currentOrder.privateNote,
              dateCreated: getDateStringFromUTCString(new Date().toUTCString()),
              items: prepareOrderItems(currentOrder),
              paymentItems: preparePaymentItems(currentOrder),
              customer: currentOrder.customer?.id > 0 ? currentOrder.customer.id : null,
            },
            { data: { id: true }, errors: true },
          ],
        }),
        {
          pending: 'Zakládám rezervaci...',
          error: 'Něco se pokazilo',
          success: 'Rezervace vytvořena',
        },
      ),
    onSuccess: async (res) => {
      const createdOrder = await core.services.order.getById(res.createOrder.data.id, Schema.order.detail)
      await printDocument(createdOrder.reservationReceiptUrl, false, true, core)
      await wait(200)
      queryClient.invalidateQueries({ queryKey: ['products', 'orders'] })
      setCurrentOrder(initOrder())
      setIsFetching(false)
      backToDashboard()
    },
    onError: error => toast.error(`${error}`)
  })

  const startCreateReservation = async () => {
    setIsFetching(true)
    if (!(await ensureCheckoutOpen())) {
      setIsFetching(false)
      return
    }
    createReservation()
  }

  const backToDashboard = () => {
    navigate('/dashboard')
  }

  return currentOrder?.items?.length > 0 ? (
    (
      <div className="w-full h-body flex flex-col overflow-y-auto">
        <div className="flex flex-row">
          <div className="w-1/2 p-4">
            <OrderFinalSummary order={currentOrder} isReservation={true}/>
          </div>
          <div className="w-1/2">
          </div>
        </div>
        <div className="flex flex-row bg-white p-4 mt-auto justify-end">

          <Btn
            className="btn-success order-draft-btn uppercase min-w-112"
            children={'Rezervovat a vytisknout potvrzení'} icon={'fa-receipt'}
            isDisabled={isFetching}
            onClick={startCreateReservation}/>
        </div>
      </div>
    )
  ) : <div>Vložte položky do objednávky</div>
}
